/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const EstimationMethod = {
    NotSpecified: 'NotSpecified',
    SameAsDayBefore: 'SameAsDayBefore',
    SameAsSevenDaysBefore: 'SameAsSevenDaysBefore',
    ControlMeter: 'ControlMeter',
    SameAs1MonthBefore: 'SameAs1MonthBefore',
    GhostMeter: 'GhostMeter',
    ZeroValueMeteringPointDisconnected: 'ZeroValueMeteringPointDisconnected',
    ZeroValueInsideDay: 'ZeroValueInsideDay',
    ManualNotSpecified: 'ManualNotSpecified',
    ManualEvenly: 'ManualEvenly',
    ManualLastPosition: 'ManualLastPosition',
    ManualProfile: 'ManualProfile',
    ManualOtherMeteringPoint: 'ManualOtherMeteringPoint',
    AdvancedVEE: 'AdvancedVEE',
    ManualAdvancedVEE: 'ManualAdvancedVEE',
    AdvancedVEELookBack: 'AdvancedVEELookBack',
    AdvancedVEEClustering: 'AdvancedVEEClustering',
    AdvancedVEEEVHandler: 'AdvancedVEEEVHandler',
    ZeroValueMeterChange: 'ZeroValueMeterChange',
} as const;
export type EstimationMethod = typeof EstimationMethod[keyof typeof EstimationMethod];

